<template>
  <div class="wrapper">
    <div class="form-row">
      <div class="col-6 container-box left">
        <div class="title">
          {{ $t('apps.settings.message.listrolepermission') }}
        </div>
        <div class="items custom-scrollbar">
          <div
            v-for="(item, index) in mapList"
            :key="index"
            class="item"
            @click="onClickAdd(item.id)"
          >
            {{ item.value }}
            <i class="fas fa-angle-right"/>
          </div>
        </div>
      </div>
      <div class="col-6 container-box right">
        <div class="title">
          {{ $t('apps.settings.message.listrolepermissionassign') }}
        </div>
        <div class="items custom-scrollbar">
          <div
            v-for="(item, index) in assigned"
            :key="index"
            class="item"
            @click="onClickRemove(item.id)"
          >
            {{ item.value }}
            <i class="fas fa-angle-left"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rolePermissionList: {
      type: Array,
      default: () => ([]),
    },
    selected: {
      type: Array,
      default: () => ([]),
    },
  },

  data () {
    return {
      list: [],
      assigned: [],
    }
  },

  computed: {
    mapList () {
      return this.rolePermissionList.reduce((acc, cur) => {
        const found = this.list.findIndex((item) => item.id === cur.permissionId) !== -1
        if (found) {
          acc.push({
            id: cur.permissionId,
            value: cur.title,
          })
        }
        return acc
      }, [])
    },
    selectedIds () {
      return this.assigned.map((item) => item.id)
    },
  },

  watch: {
    assigned: {
      handler: function () {
        this.$emit('update:selected', this.selectedIds)
      },
      deep: true,
    },
  },

  created () {
    this.initState()
  },

  methods: {
    initState () {
      this.list = this.rolePermissionList.map((item) => {
        return {
          id: item.permissionId,
          value: item.title,
        }
      })
      if (this.selected.length) {
        this.selected.forEach((id) => {
          this.onClickAdd(id)
        })
      }
    },
    addItem (key = '', id = '') {
      const item = this.rolePermissionList.find((item) => id === item.permissionId)
      if (item) {
        this[key].push({
          id: item.permissionId,
          value: item.title,
        })
      }
    },
    removeItem (key = '', id = '') {
      const index = this[key].findIndex((item) => item.id === id)
      this[key].splice(index, 1)
    },
    onClickAdd (id) {
      this.addItem('assigned', id)
      this.removeItem('list', id)
    },
    onClickRemove (id) {
      this.removeItem('assigned', id)
      this.addItem('list', id)
    },
  },
}
</script>

<style scoped>
.wrapper {
  background-color: #F0F0F0;
  padding: 15px;
}

.container-box .title {
  margin-bottom: 6px;
}

.container-box .items {
  width: 100%;
  height: 207px;
  background-color: #fff;
  border: solid 1px #D2D2D2;
  overflow-y: auto;
}

.container-box .items .item {
  position: relative;
  padding: 10px 15px;
  cursor: pointer;
}

.container-box .items .item:hover {
  background-color: #E6E6E6;
}

.container-box .items .item i {
  display: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
}

.container-box.left .items .item i {
  right: 20px;
}

.container-box.right .items .item i {
  left: 20px;
}

.container-box .items .item:hover i {
  display: block;
}

.container-box.right .items .item:hover {
  padding-left: 46px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseSelectRolePermission.vue